import { request } from '../request'

// 新增评论
export function addComment(data) {
  return request({
    url: '/comment/wjcomment/add',
    method: 'post',
    data
  })
}

// 批量新增评价
export function batchAddAppraise(data) {
  const dt = Array.isArray(data) ? data[0] : data;
  const businessKey = ['', null, undefined].includes(dt?.businessKey) ? '' : `?businessKey=${dt.businessKey}`
  return request({
    url: `/comment/wjevaluate/batchAddEvaluate${businessKey}`,
    method: 'post',
    data
  })
}

// 批量添加全部评价
export function batchAddAppraiseAll(data) {
  return request({
    url: '/center/investigatorStatement/batchAddEvaluateByQuery',
    method: 'post',
    data
  })
}

// 树形结构评论
export function getComments(params) {
  return request({
    url: '/comment/wjcomment/listTree',
    method: 'get',
    params
  })
}

// 通过业务id获取评价详情
export function getEvaluateByBusinessId(params) {
  return request({
    url: '/comment/wjevaluate/getEvaluateByBusinessId',
    method: 'get',
    params
  })
}

// 获取评论数量
export function getCommentNum(data) {
  return request({
    url: '/comment/wjcomment/getCommentNumByBusinessIds',
    method: 'post',
    data
  })
}

// 更新评论
export function editComment(data) {
  return request({
    url: '/comment/wjcomment/updateComment',
    method: 'post',
    data
  });
}
